import { type FC } from 'react';

import CarouselComponent, { type CarouselProps } from 'components/Carousel';

const Carousel: FC<CarouselProps> = (props) => (
  <CarouselComponent height="full" {...props} />
);

export default Carousel;
